import { Chip, ChipTypes } from '../chips';
import { WordpressIcon } from '../icons/icons';
import { Icon } from '../icon';
import React from 'react';
import styles from './content-list-item.css';

interface Props {
  title: string;
  wordpressEnabled: boolean;
  url: string;
  type?: ChipTypes;
}

const WordpressLogo = () => (
  <Icon className={styles.wordpressIcon} data-testid="wordpress-logo">
    <WordpressIcon />
  </Icon>
);

export const ContentContainer = ({ title, wordpressEnabled, url, type }: Props) => (
  <div className={styles.contentWrapper}>
    <div className={styles.titleWrapper}>
      <h3 className={styles.title} data-testid="page-title">
        {title}
        {wordpressEnabled && <WordpressLogo />}
      </h3>
      <h6 className={styles.url} data-testid="page-link-text">
        {url}
      </h6>
    </div>
    {type && <Chip type={type} />}
  </div>
);

export default ContentContainer;
